import { Component } from '@angular/core';
import { SharingDataService } from 'src/sharing-data.service';
import { AuthService }  from '../../AuthService';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

  constructor(private sharingDataService : SharingDataService,private authService : AuthService) {}

  ngOnInit(){
    this.getCustomerId();
    
  }

  
  address = {
      Name: '',
      Contact: '',
      Address: '',
      City: '',
      State: '',
      Pincode: '',
      Landmark:'',
      Country:'India',
      Street:'',
      Email:'',
      Address_type: 'Home',
      CustomerId:0
    };

    addressDetails:any;
    addressId:number=0;
    addressDetailsByAddressId:any;
    addressDetailsByCustomerId:any;
    customerId:any;
    orderDetailsByCustomerId:any;

displayDetails=false;
  getCustomerId(){
      
   //  this.sharingDataService.loggedInCustomerIdVal.subscribe(val => {
     let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token != null || token != undefined){
       this.customerId= localStorage.getItem('customerId');

    if(this.customerId!=null || this.customerId!=undefined){
        this.getAddressByCustomerId();
        this.  getOrderByCustId();
    }
    
      
//  });
}
  }



  editAddress() {
    alert('Redirecting to address update page...');
  }

  viewOrder(orderId: string) {
    alert(`Viewing details for order ${orderId}`);
  }


  getOrderByCustId() {
    this.sharingDataService.getOrderbyCustomerId(this.customerId).subscribe({
      next:(response) =>{
         console.log('Order Details',response);
          this.orderDetailsByCustomerId=response;

      }
    })
  }
  logout() {
    localStorage.removeItem('jwt');
    alert('Logged out successfully!');
    // Redirect to login page
  }

  getAddressByAddressId(){
     this.sharingDataService.getAddressByAddressId(this.addressId).subscribe({
      next:(response) =>{
         console.log('Address Details',response);
          this.addressDetailsByAddressId=response;

      }
    })
  }

   getAddressByCustomerId(){
     this.sharingDataService.getAddressByCustomerId(this.customerId).subscribe({
      next:(response) =>{
         console.log('Address Details',response);
          this.addressDetailsByCustomerId=response;
           this.displayDetails=true;
      }
    })
  }

  deleteAddressByAddressId(){
    this.sharingDataService.deleteAddressByAddressId(this.addressId).subscribe({
      next:(response) =>{
         console.log('Address deleted',response);
         
          this.getAddressByCustomerId();
      }
    })
  }
}
